module.exports = __webpack_public_path__ + "img/bottom-bar.438d3a71.png";